import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../features/auth";
import type { IRoadWebCamera } from "../../models/storeModels/IRoadWebCamera";

function getInitialState(){
    const initialState: IRoadWebCamera = {
        name: '',
        cameraInfoWindowIsShown: false,
        cameraInfo: {
            direction: null,
            road: null,
            km: null
        }
    }
    return initialState
}

export const roadWebCameraSlice = createSlice({
    name: 'roadWebCamera',
    initialState: getInitialState(),
    reducers: {
        changeRoadWebCameraName(state, action: PayloadAction<any>) {
            state.name = action.payload
        },
        setCameraInfoWindowIsShown(state, action: PayloadAction<any>) {
            state.cameraInfoWindowIsShown = action.payload
        },
        setRoadWebCameraInfo(state, action: PayloadAction<any>) {
            state.cameraInfo = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const { changeRoadWebCameraName, setCameraInfoWindowIsShown, setRoadWebCameraInfo } = roadWebCameraSlice.actions
export const roadWebCameraReducer = roadWebCameraSlice.reducer;
